import { gql } from '@apollo/client';

export default gql`
mutation createOrder($order: CreateOrderInput!) {
	createOrder(order: $order) {
    success
    _id
    orderNum
    message
  }
}
`;
